import { render, staticRenderFns } from "./MenuLibraryPanel.vue?vue&type=template&id=687f85b7&scoped=true&"
import script from "./MenuLibraryPanel.vue?vue&type=script&lang=js&"
export * from "./MenuLibraryPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuLibraryPanel.vue?vue&type=style&index=0&id=687f85b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f85b7",
  null
  
)

export default component.exports